import { ColumnsType } from "antd/es/table";
import { useIntl } from "react-intl";
import { useMemo } from "react";
import {
  renderTableAmountColumn,
  renderTableDateColumn,
} from "utils/tableUtils";
import { Refund } from "@ticketingplatform/api/dist/refund/__generated__/fragments";

import { UseRefundColumnsProps } from "./types";

export const useRefundColumns = ({
  additionalColumns = [],
}: UseRefundColumnsProps): ColumnsType<Refund> => {
  const intl = useIntl();

  return useMemo<ColumnsType<Refund>>(
    () => [
      {
        key: "createdAt",
        dataIndex: "createdAt",
        title: intl.formatMessage({ defaultMessage: "Refund Time" }),
        render: renderTableDateColumn(),
      },
      {
        key: "amount",
        dataIndex: "amount",
        title: intl.formatMessage({ defaultMessage: "Refund Amount" }),
        render: renderTableAmountColumn(),
      },
      {
        key: "method",
        dataIndex: "method",
        title: intl.formatMessage({ defaultMessage: "Form of Refund" }),
      },
      {
        key: "reason",
        dataIndex: "reason",
        title: intl.formatMessage({ defaultMessage: "Reason" }),
      },
      ...additionalColumns,
    ],
    [intl, additionalColumns]
  );
};
